import { useEffect } from 'react';
import type { NextRouter } from 'next/router';

import { Topic, messageFactory, ApplicationScreenViewed } from '@annunciate/core/dist/events';
import { rootScrollMap, rootScrollViewRef } from '@annunciate/web/dist/utils';

export const useNextPageviewListener = (router: NextRouter) => {
  useEffect(() => {
    const scrollY = rootScrollMap[window.location.pathname] || 0;
    rootScrollViewRef.current?.scrollTo({x: 0, y: scrollY, animated: false});
    messageFactory<ApplicationScreenViewed>(
      Topic.APP_SCREEN_VIEWED,
      {
        path: window.location.pathname,
        title: document.title,
      },
    )
  }, [router]);
}
